import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'filterValueArray',
})
export class FilterValueArray implements PipeTransform {
  transform(value: string[], remove: string | string[]): string[] {
    const finalList = Array.isArray(remove) ? remove : [remove];
    return value.filter(item => !finalList.includes(item));
  }
}